module.exports = __webpack_public_path__ + "img/sonicare2.7ed33110.jpg";